import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { svgIconList } from '@shared/svg-icon-list';

@Component({
  selector: 'app-popup-service-worker',
  imports: [CommonModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './popup-service-worker.component.html',
  styleUrls: ['./popup-service-worker.component.scss']
})
export class PopupServiceWorkerComponent implements OnInit {

  svg: any = svgIconList;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { type?: string, newVersion?: string }, // type of popup: 1. connection-err; 2. force-reload;
    public dialogRef: MatDialogRef<PopupServiceWorkerComponent>,
  ) { }

  ngOnInit() {
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }

  onReload() {
    if(this.data.newVersion){
      localStorage.setItem('version', this.data.newVersion);
    }
    window.location.reload();
  }

}
